componentRegistryInstance.register('icon', 'read', 'hrd.components.form.IconComponent');

hrd.components.form.IconComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.IconComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	getReadOnlyField: function(field, name, object, options) {
		// do nothing: do not call 'super'
	},
	/**
	 * TODO: rewrite this function using 'interpolation' and simplifying it a bit
	 */
	setReadOnlyField: function(field, value, object, options) {
		let name = this.getFieldName();
		let fnName = $.functionCase(`${name}-icon-options`);

		if (this.settings.reference && typeof this.settings.reference[fnName] === 'function') {
			let iconOptions = this.settings.reference[fnName].call(this.settings.reference, value, object);

			if (iconOptions.hideIcon === true) {
				field.hide();
			} else {
				let styles = [];
				if (iconOptions.color != undefined) {
					styles.push('color:{color};');
				}
				if (iconOptions.fontSize != undefined) {
					styles.push('font-size:{fontSize};');
				}
				/* fix for bypass double quotes in tooltips */
				iconOptions.tooltip = this.toolbox.escapeTooltip(iconOptions.tooltip);

				let sStyle = styles.length == 0 ? '' : ` style="${styles.join(' ')}"`;
				let sTooltip = iconOptions.tooltip == undefined ? '' : ' title="{tooltip}"';

				let iconTemplate = `<i class="f-icon {icon}"${sStyle}${sTooltip}></i>`;

				let icon = hrd.utils.replaceParams(iconTemplate, iconOptions);
				field.html(icon).show();
				$('.f-icon', field).tooltip();
				if (iconOptions.action) {
					let fnAction = $.functionCase(`${name}-icon-action`);
					if (typeof this.settings.reference[fnAction] === 'function') {
						field
							.off('click.icon-action')
							.on('click.icon-action', evt => {
								this.settings.reference[fnAction].call(this.settings.reference, evt, object, this.getFormInstance());
							});
					} else {
						console.log(`For defining the icon action, add method "${fnAction}: function(evt, formData, formInstance) {}," to "${this.settings.reference._FULL_}"`);
					}
				}
			}
		} else {
			if (this.settings.reference) {
				console.log(`For defining the icon options, add method "${fnName}: function(status, formData) {}," to "${this.settings.reference._FULL_}"`);
			}
			field.text((value != undefined) ? value : '');
		}
	}
});